import script from "./TimelineComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TimelineComponent.vue?vue&type=script&setup=true&lang=js"

import "./TimelineComponent.vue?vue&type=style&index=0&id=fa050048&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa050048"]])

export default __exports__